export default "__VITE_ASSET__B1eFXgD0__"